var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83391 1.50293C7.79641 -0.163737 10.2031 -0.163737 11.1647 1.50293L17.2939 12.1263C18.2556 13.7929 17.0522 15.8763 15.1281 15.8763H2.87058C0.946409 15.8763 -0.256091 13.7929 0.705575 12.1263L6.83308 1.50293H6.83391ZM8.99974 5.87543C9.1655 5.87543 9.32447 5.94128 9.44168 6.05849C9.55889 6.1757 9.62474 6.33467 9.62474 6.50043V9.62543C9.62474 9.79119 9.55889 9.95016 9.44168 10.0674C9.32447 10.1846 9.1655 10.2504 8.99974 10.2504C8.83398 10.2504 8.67501 10.1846 8.5578 10.0674C8.44059 9.95016 8.37474 9.79119 8.37474 9.62543V6.50043C8.37474 6.33467 8.44059 6.1757 8.5578 6.05849C8.67501 5.94128 8.83398 5.87543 8.99974 5.87543ZM8.99974 12.7504C9.1655 12.7504 9.32447 12.6846 9.44168 12.5674C9.55889 12.4502 9.62474 12.2912 9.62474 12.1254C9.62474 11.9597 9.55889 11.8007 9.44168 11.6835C9.32447 11.5663 9.1655 11.5004 8.99974 11.5004C8.83398 11.5004 8.67501 11.5663 8.5578 11.6835C8.44059 11.8007 8.37474 11.9597 8.37474 12.1254C8.37474 12.2912 8.44059 12.4502 8.5578 12.5674C8.67501 12.6846 8.83398 12.7504 8.99974 12.7504Z",
    fill: "#CC7729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fa4a804631cb96331575023a88d128cc.svg";
export { ForwardRef as ReactComponent };